var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 108,
    viewBox: "0 0 112 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76755 105.201C2.76755 105.201 2.98166 80.2258 2.98166 54.8379C2.98166 5.66283 -2.60001 2 27.1192 2H109.842V72.9305C109.842 96.2798 115.721 105.427 82.6694 105.427C49.6178 105.428 2.76755 105.201 2.76755 105.201Z",
    fill: "#A62C39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9708 11.2771C70.9708 11.2771 76.2723 12.0652 80.8654 17.8359C85.4597 23.6075 109.843 68.4712 109.843 68.4712V32.0027L87.2272 4.71753L93.5879 10.49L105.603 3.14316L90.0539 2.35682L70.9708 11.2771Z",
    fill: "url(#paint0_linear_212_153)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.668,
    d: "M23.9713 2.61895C23.9713 2.61895 58.9567 19.9345 75.9192 23.3454C92.8818 26.7571 110.55 30.4292 110.55 30.4292L70.2647 103.889L87.5803 104.414L110.199 62.9609L109.49 2.35684L23.9713 2.61895Z",
    fill: "url(#paint1_radial_212_153)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4819 80.0144L92.8761 106L25.0316 104.938C25.0316 104.938 22.9121 88.9347 23.6182 80.5394L27.8583 72.1442L56.4819 80.0144Z",
    fill: "white",
    fillOpacity: 0.44
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0528 105.464L57.1891 80.2773L27.1511 71.8821L3.82785 33.3158L28.5656 2.61977L11.9561 2.09469L5.2412 6.81781L2.76755 10.4908L1 105.989L90.0528 105.464Z",
    fill: "black",
    fillOpacity: 0.362
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.197 65.3225C110.197 65.3225 76.9795 73.1935 57.1903 80.5394C37.401 87.8854 26.7991 105.725 26.7991 105.725C26.7991 105.725 69.2044 104.152 85.1066 104.676C101.009 105.201 108.43 105.201 109.843 88.6726C111.257 72.1442 110.197 65.3225 110.197 65.3225Z",
    fill: "#83222D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0073 80.9918V96.487H18.3304V92.4512L23.1752 96.0481H31.3433L24.8653 91.2388C24.8653 91.2388 29.5268 91.1821 29.8787 86.1791C29.8787 81.5879 25.2127 80.9926 19.8223 80.9926L13.0073 80.9918ZM18.5844 85.1949H23.1752V87.9556H18.5844V85.1949Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.624 81.0544C38.7096 81.0417 34.6677 81.2429 34.6677 85.3201V96.0896H40.1309V93.4549H45.4268V96.027H50.9185V84.7358C50.9185 81.1939 45.6181 81.0552 42.7788 81.0552L41.624 81.0544ZM40.2152 84.9438H45.3413V89.1892H40.2152V84.9438Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3942 81.0637H62.0476V95.8866H56.3942V81.0637Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9664 81.2615V96.0845H81.5727V92.1494H73.5333V81.1956L67.9664 81.2615Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5944 81.1296V85.1307H90.4947V86.574H94.3817C96.4146 86.574 100.655 86.5089 100.655 91.2312C100.655 95.9534 97.738 96.2164 91.8192 96.2164H84.6636V92.6085H92.8795C95.3532 92.6085 95.4898 92.0099 95.4898 91.489C95.4898 90.969 94.2257 90.7264 91.6529 90.7264C89.0802 90.7264 84.3105 89.7878 84.3105 86.1149C84.3105 82.4419 86.7842 81.0645 91.7315 81.0645C96.68 81.0637 99.5944 81.1296 99.5944 81.1296Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9637 76.6044H64.9643C64.9643 76.6044 54.539 59.0267 57.1903 42.8906C59.8393 26.7562 76.9795 19.4094 86.6976 18.6222C96.4157 17.8351 101.716 22.2952 101.716 22.2952L103.836 19.9345C103.836 19.9345 89.8774 9.4398 72.2076 10.621C54.539 11.8005 42.3472 20.4587 34.7497 30.9526C27.1522 41.4473 22.7345 48.7941 19.7301 59.8122C16.7269 70.8319 17.9637 76.6044 17.9637 76.6044Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59977 59.0267L17.786 59.5509L16.1961 66.3726L7.53833 65.5854L8.59977 59.0267Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0875 44.596L25.5612 39.4806L17.433 37.119L14.7828 42.6285L23.0875 44.596Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.572 27.0183L39.3428 22.8203L33.1587 19.8034L28.2125 23.8704L34.572 27.0183Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1168 10.7529L51.358 14.5569L57.1891 12.0652L52.9479 8.52325L47.1168 10.7529Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.791 6.42381L68.8502 10.2278L76.0946 10.0968L75.3885 6.68592L67.791 6.42381Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3499 10.49L92.1734 12.8507L97.1196 14.8191L98.1799 13.6387L92.3499 10.49Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2908 20.5906V22.5582L96.0615 22.9513V21.3778L91.2908 20.5906Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0946 22.2952L78.3918 25.444L81.7492 23.4764L81.0419 21.3778L76.0946 22.2952Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8502 26.3622L72.3841 30.2981L70.2635 33.052L65.1397 28.854L68.8502 26.3622Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7823 37.2509L59.4851 40.6609L65.4927 44.4658L66.9061 40.1359L61.7823 37.2509Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3086 49.1873L58.9556 53.7785L66.3765 56.1392L66.0223 51.8109L59.3086 49.1873Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4292 65.4535L63.1968 70.1766L72.5618 70.5698L69.2032 65.4535H61.4292Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76755 105.201C2.76755 105.201 2.98166 80.2258 2.98166 54.8379C2.98166 5.66283 -2.60001 2 27.1192 2H109.842V72.9305C109.842 96.2798 114.308 105.427 82.6694 105.427C51.0312 105.428 2.76755 105.201 2.76755 105.201Z",
    stroke: "#5E000E",
    strokeWidth: 3.41665
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_212_153",
    x1: 82.4291,
    y1: 42.2269,
    x2: 104.243,
    y2: 26.8359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0815E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_212_153",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.2603 52.9604) scale(43.74 51.3729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A94436"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRails);
export default __webpack_public_path__ + "static/media/rails.a732afdf6d7b75ef5284c2fe2cedcccb.svg";
export { ForwardRef as ReactComponent };